// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__13fvZ","amount":"Amount_amount__1slux","tip":"Amount_tip__11S2Z","tipHeader":"Amount_tipHeader__3Q8D3","tipsWrap":"Amount_tipsWrap__3G-k-"};